// images
import TeachingLicense from "../assets/images/teaching-license.png";
import PythonCertificate from "../assets/images/python-certificate.png";
import PythonTest from "../assets/images/python-test.png";
import BrainsterNext from "../assets/images/brainster-next.png";
import BrainsterCertificate from "../assets/images/brainster-certificate.png";
// import Goethe from "../assets/images/goethe.png";

const certifications = [
  {
    image: BrainsterCertificate,
    link: "https://brainster-learn.s3.eu-central-1.amazonaws.com/front_end/excellency/Lutmira_Peci_front_end_excellency_1743535146_cbc.pdf",
    title: "Frontend Academy",
  },
  {
    image: BrainsterNext,
    link: "https://brainster-learn.s3.eu-central-1.amazonaws.com/front_end/excellency/Lutmira_Peci_front_end_excellency_1743535161_next.pdf",
    title: "Frontend Academy",
  },
  {
    image: PythonCertificate,
    link: "https://app.diplomasafe.com/en-US/diploma/d7dc6efe201fde6e3720c8abf859ffb913d0bf522",
    title: "Python From Scratch",
  },
  {
    image: PythonTest,
    link: "https://www.testdome.com/certificates/7d17becc7d8a42759f7229be45b0a2e7",
    title: "Python TestDome",
  },
  {
    image: TeachingLicense,
    link: "https://drive.google.com/file/d/1SpxQGrIWTT2ftRUVaoJ2BLAK3cgDj5P1/view?usp=sharing",
    title: "Teaching License",
  },
  // {
  //   image: Goethe,
  //   link: "https://drive.google.com/file/d/1VNJJQeUfgoasgii3E8kUg_3-7khq2DUh/view",
  //   title: "Goethe Zertifikat A2",
  // },
];

export default certifications;
